import Vue from 'vue';
// import echarts from "echarts";
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;

export default echarts;
